import React from 'react'
import ItemWithStatusOperable from '../ItemSelectable/ItemWithStatusOperable'
import equipmetsOrToolImg from '../../assets/equipment-tools-access-icon.svg';

export const EquipmetsOrTool = ({ editFn = null, deleteFn = null, type = '', details = '-' }) => {
  return (
    <ItemWithStatusOperable
      onCLickEdit={editFn}
      onClickDelete={deleteFn}
    >
      <div className='d-flex align-items-center gap-2'>
        <img
          src={equipmetsOrToolImg}
          alt="equipmetsOrToolImg"
        />
        <div>
          <p className='m-0 vehicleName-card'>{type}</p>
          <p className='m-0 vehiclePatent-card'>{details}</p>
        </div>
      </div>
    </ItemWithStatusOperable>

  )
}
